import { QueueRule } from '@rossum/api-client/schemas';

export const useCombinedRuleQueueUrls = ({ rule }: { rule?: QueueRule }) => {
  const queues = rule?.queues ?? [];
  return { queues };
};
